import { active } from "../components/MobileMenu";
import React, { useContext } from "react";
import { GlobalContext } from "../context/GlobalState";

export const activateMobileMenu = () => {
  document.getElementById("mobile-menu").classList.add(active);
};

export const deactivateMobileMenu = () => {
  document.getElementById("mobile-menu").classList.remove(active);
};
